import React from 'react';
import { OpPage } from 'components/customAntd/OpPage/OpPage';
import RepeatVisitorsTable from './RepeatVisitorsTable';
import { useTranslation } from 'react-i18next';

const RepeatVisitors: React.FC = () => {
    const { t } = useTranslation();

    return (
        <OpPage title={t('repeatVisitors.title')} tooltip={t('repeatVisitors.tooltip')}>
            <RepeatVisitorsTable />
        </OpPage>
    );
}

export default RepeatVisitors;
